import { IClonable } from "..";
import { AbstractPropertyPresenter } from "./AbstractPropertyPresenter";

export class PropertyPresenter<TSource, TValue> extends AbstractPropertyPresenter<TSource, TValue> implements IClonable<PropertyPresenter<TSource, TValue>> {
  constructor(source: { source: TSource, read: (s: TSource) => TValue } | PropertyPresenter<TSource, TValue>) {
    super((source instanceof PropertyPresenter) ? source : source.source);
    this._read = (source instanceof PropertyPresenter)
      ? source._read
      : source.read;
  }

  private readonly _read: (s: TSource) => TValue;

  readValue(source: TSource): TValue {
    return this._read(source);
  }

  clone(): PropertyPresenter<TSource, TValue> {
    // TODO: 使い方的にcloneしない？しないならcloneのための諸実装は削除が望ましい.
    return new PropertyPresenter(this);
  }
}
